import React, { useEffect, useState } from "react";
import ViewModal from "@core/modals/ViewModal";
import ViewButton from "@core/buttons/atoms/ViewButton";
import RowDetails from "@hoc/cruds/RowDetails";
import { useTranslation } from "react-i18next";
import PermissionHandler from "@hoc/cruds/PermissionHandler";
import VesselTypeService from "@services/VesselTypeService";

const ShowVesselType = ({ vesselType }) => {
  const { t } = useTranslation();
  const [showModal, setShowModal] = useState(false);
  const [vesselTypeData, setVesselTypeData] = useState([]);

  const closeModal = () => {
    setShowModal(false);
  };
  useEffect(() => {
    if (showModal)
      VesselTypeService.find(vesselType.id).then((response) => {
        setVesselTypeData(response.data.data);
      });
  }, [vesselType.id, showModal]);

  return (
    <PermissionHandler permission={"view_vessel_types"}>
      <ViewButton onClick={() => setShowModal(true)} />
      <ViewModal
        show={showModal}
        title={`${t("overview")}`}
        onClose={closeModal}
      >
        <div className="flex flex-col mt-5">
          <RowDetails label={t("name")} value={vesselTypeData.name} />
          <RowDetails label={t("nameEng")} value={vesselTypeData.name_eng} />
          <RowDetails
            label={t("stdAbbreviation")}
            value={vesselTypeData.std_abbreviation}
          />
          <RowDetails
            label={t("description")}
            value={vesselTypeData.description}
          />
          <RowDetails
            label={t("vesselTypeFFFAOName")}
            value={vesselTypeData.vessel_type_fffao?.name}
          />
        </div>
      </ViewModal>
    </PermissionHandler>
  );
};

export default ShowVesselType;
